import React from "react";
import NewsletterTwentyFive from "../component/NewsletterTwentyFive";

function NewsletterTwentyFiveContainer() {
  return <NewsletterTwentyFive />;
}

export default NewsletterTwentyFiveContainer;
